import {client, xml} from '@xmpp/client'

//export const default_avatar = "https://ifrit.fr/avatar.png"

let xmpp 
export const createXMPPConnexion = async (user, params, notification)=>{
    const queryid = 'mam1'
    

    //params.onGetVcardReady(getVcard)
    xmpp = client({
        service: 'wss://ifrit.fr:5281/xmpp-websocket',
        domain: 'ifrit.fr',
        username: user.pseudo,
        password: user.password,
    })

    params.onXMPPREady(xmpp, xml)
    const mamQuery = xml(
            'iq',
            { type: 'set', id: queryid },
            xml('query', { xmlns: 'urn:xmpp:mam:2', queryid },
                xml('x', { xmlns: 'jabber:x:data', type: 'submit' },
                    xml('field', { var: 'FORM_TYPE', type: 'hidden' },
                        xml('value', {}, 'urn:xmpp:mam:2')
                    )
                ),
                xml('set', { xmlns: 'http://jabber.org/protocol/rsm' },
                    xml('max', {}, '360'),
                    xml('before')   
                    
                )
            )
        )


    xmpp.on('error', err => {
        console.error('❌', err.toString())
    })
    
    xmpp.on('offline', () => {
        console.log('⏹', 'offline')
    })

    xmpp.on('stanza', async stanza => {
        //console.log("stanza: ", stanza.toString())
        if (stanza.is('presence')) {
            if(stanza.attrs && stanza.attrs.from){ 
                const from = stanza.attrs.from.split('/')[0]; // JID sans ressource
                const type = stanza.attrs.type || 'available';

                if (type === 'unavailable') {
                    console.log("stanza presence", from, "est offline");
                    params.onPresence(from, false)
                // marquer utilisateur comme offline dans state.users[from].status
                } else if (type !== 'error') {
                    console.log("stanza presence", from, "est online", type);
                    params.onPresence(from, true)
                // tu peux aussi lire <show>away</show> ou <status>message perso</status>
                }
            }
        }
        else
        if (stanza.is('message')) {
            const forwarded = stanza.getChild('result', 'urn:xmpp:mam:2')?.getChild('forwarded', 'urn:xmpp:forward:0')
            const message = forwarded?.getChild('message')
            let msgId = stanza.attrs.id ||
                stanza.getChild('origin-id', 'urn:xmpp:sid:0')?.attrs.id ||
                stanza.getChild('stanza-id', 'urn:xmpp:sid:0')?.attrs.id ||
                null;

            if (forwarded) {
                const inner = forwarded.getChild('message');
                msgId =
                    inner?.attrs.id ||
                    inner?.getChild('origin-id', 'urn:xmpp:sid:0')?.attrs.id ||
                    inner?.getChild('stanza-id', 'urn:xmpp:sid:0')?.attrs.id ||
                    msgId ||
                    // fallback: id du <result/> MAM (identifiant d’archive)
                    stanza.attrs.id ||
                    null;
            }

            const result = stanza.getChild('result', 'urn:xmpp:mam:2')
            if(result){
                msgId = msgId || result.attrs.id
            }

            const body = message?.getChildText('body')||stanza.getChildText('body')

            
            
            try{ 
                let from = message?.attrs.from||stanza.attrs.from
                let to = message?.attrs.to||stanza.attrs.to
                
                /*const displayed = stanza.getChild('displayed', 'urn:xmpp:chat-markers:0')||(message ? message.getChild('displayed', 'urn:xmpp:chat-markers:0'):undefined)
                if(displayed){
                    params.onMessageDisplayed(displayed.attrs.id)
                    //console.log("displayed", displayed.attrs.id, displayed)
                }*/
                
                

                if(body){
                    let is_room = false
                    let room = ""
                    if (from.includes('@conference.ifrit.fr')) {
                        is_room = true
                        const pseudo = from.split("/")[1]
                        room = from.split("@")[0]

                        from = `${pseudo}@ifrit.fr`
                    }
                    else { 
                        from = from.split("/")[0]
                        //console.log("createXMPPConnexion.on.stanza", from, to, body, stanza.toString())
                    }

                    const delay = forwarded?.getChild('delay', 'urn:xmpp:delay') || stanza.getChild('delay')
                    const stamp = delay ? delay.attrs["stamp"] : (new Date()).toISOString()
                    let at = formatRelativeTime(stamp)
                    const isHistorical = !!delay


                    if(!is_room) params.onUserMessage(from, to, body, msgId, at, stamp, !isHistorical)
                    else{
                        params.onRoomMessage(from, room, body, msgId, at, stamp, !isHistorical)
                    }
                   
                }else{
                    
                }
            }catch(e){
                console.log("stanza.error", e)
            }
        } else if (stanza.is('iq') && stanza.attrs.id === queryid) {
        }
    })
    xmpp.on('online', async address => {

        console.log("xmpp.on.online", address)

        const sendPrersence = async ()=>{ 
            await xmpp.send(
                xml('presence', { },
                    xml('show', {}, 'chat'),          // dispo
                    xml('status', {}, 'En ligne 🚀')  // texte custom
                )
            )
        }
        sendPrersence()
        setInterval(()=>{
            sendPrersence()
        }, 5*1000*60)

        let jid = address.toString().split("/")[0]
        let pseudo =jid.split("@")[0]
        
        if(user.chat_rooms && user.chat_rooms.length > 0){
            for(let i=0; i < user.chat_rooms.length; i ++){
                /*await createOrConfigureRoom(xmpp, user.chat_rooms[i] + '@conference.ifrit.fr', pseudo, {
                    public: false,
                    membersOnly: true,
                    name: 'monde'
                })
                setTimeout(()=>{
                    joinRoom(xmpp, user.chat_rooms[i] + '@conference.ifrit.fr', pseudo)
                }, 100 + i*50)*/

                const response = await fetch(`/xmpp/room/add/${pseudo}/${user.chat_rooms[i]}`, {
                    "method": "post"
                })
                if(response.status === 200) {
                    setTimeout(()=>{
                        joinRoom(xmpp, user.chat_rooms[i] + '@conference.ifrit.fr', pseudo)
                    }, 100 + i*50)
                }
                
            }

        }

        
        

        await xmpp.send(mamQuery)
        await xmpp.send(xml('presence'))

        params.onOnLine(xmpp, jid)
        
    })

    xmpp.on('status', status => {
        console.debug('🛈', 'status', status)
    })
    xmpp.on('input', input => {
        //console.debug('⮈', input)
    })
    xmpp.on('output', output => {
        //console.debug('⮊', output)
    })
      
    xmpp.start().catch(console.error)

    
    return xmpp
}

const joinRoom = (xmpp, roomJid, nickname) => {
    const presence = xml(
      'presence',
      { to: `${roomJid}/${nickname}` },
      xml('x', { xmlns: 'http://jabber.org/protocol/muc' })
    )
    xmpp.send(presence)
  }

async function isRoomMembersOnly(xmpp, roomJid) {
  const iq = xml(
    "iq",
    { type: "get", to: roomJid, id: "check-room-config" },
    xml("query", { xmlns: "http://jabber.org/protocol/muc#owner" })
  )

  try {
    const response = await xmpp.sendReceive(iq)

    const form = response.getChild("query", "http://jabber.org/protocol/muc#owner")
                       ?.getChild("x", "jabber:x:data")

    const fields = form?.getChildren("field") || []

    for (const field of fields) {
      if (field.attrs.var === "muc#roomconfig_membersonly") {
        const value = field.getChildText("value")
        return value === "1" // true si la room est membersOnly
      }
    }

    return false
  } catch (err) {
    console.error("Erreur lors de l'interrogation de la room :", err)
    return null
  }
}


let buzzVcard = false
const getVcard = async (xmpp, jid, cb)=>{
    if(!buzzVcard){
        buzzVcard = true
        await getVcardAsync(xmpp, jid, cb)
        buzzVcard = false
    }
    else {
        setTimeout(async ()=>{
            await getVcard(xmpp, jid, cb)
        }, 20)
    }
}
export const getVcardAsync = async (xmpp, jid, cb)=>{

    return new Promise(async (resolving) => {
        setTimeout(async ()=>{
            const vCard = xml(
                'iq',
                { type: 'get', to: jid, id: 'v1' },
                xml('vCard', { xmlns: 'vcard-temp' })
            )
            try {
                const response = await xmpp.sendReceive(vCard)
        
            
                const b64 = response.getChild('vCard')?.getChild('PHOTO')?.getChildText('BINVAL')
                const type = response.getChild('vCard')?.getChild('PHOTO')?.getChildText('TYPE') || 'image/jpeg'
            
                if (b64) {
                    const imgSrc = `data:${type};base64,${b64}`
                    if(cb) cb(imgSrc)
                    resolving(imgSrc)
                    return
                } 
            } catch (err) {
                console.error('Erreur lors de la récupération du vCard:', err)
            }
            if(cb) cb()
            resolving ()

        }, 200)
    })

    

}



const createOrConfigureRoom = async (xmpp, roomJID, nickname, options = {}) => {
    // Rejoindre la room (la crée si elle n'existe pas)
    const presence = xml('presence', { to: `${roomJID}/${nickname}` },
      xml('x', { xmlns: 'http://jabber.org/protocol/muc' })
    )
    xmpp.send(presence)
  
    // Configurer la room
    const configFields = [
      xml('field', { var: 'FORM_TYPE', type: 'hidden' },
        xml('value', {}, 'http://jabber.org/protocol/muc#roomconfig')
      ),
      xml('field', { var: 'muc#roomconfig_persistentroom' },
        xml('value', {}, '1')
      ),
      xml('field', { var: 'muc#roomconfig_publicroom' },
        xml('value', {}, options.public ? '1' : '0')
      ),
      xml('field', { var: 'muc#roomconfig_membersonly' },
        xml('value', {}, options.membersOnly ? '1' : '0')
      ),
      xml('field', { var: 'muc#roomconfig_roomname' },
        xml('value', {}, options.name || roomJID)
      )
    ]
  
    const configIQ = xml('iq', { type: 'set', to: roomJID, id: 'room-config' },
      xml('query', { xmlns: 'http://jabber.org/protocol/muc#owner' },
        xml('x', { xmlns: 'jabber:x:data', type: 'submit' },
          ...configFields
        )
      )
    )
    xmpp.send(configIQ)
  }


export const  formatRelativeTime = (timestamp) => {
    const now = new Date()
    const past = new Date(timestamp)
    const diffMs = now - past

    const seconds = Math.floor(diffMs / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    if (seconds < 30) {
        return "à l’instant"
    } else if (minutes < 60) {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`
    } else if (hours < 24) {
        return `${hours} heure${hours > 1 ? 's' : ''}`
    } else {
        return formatFullDate(past)
    }
}

export const formatFullDate = (date)=> {
    const jours = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
    const mois = [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
    ]

    const jour = date.getDate()
    const moisNom = mois[date.getMonth()]
    const année = date.getFullYear()
    const heures = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')

    return `le ${jour} ${moisNom} ${année} à ${heures}h${minutes}`
}